
<template>
  <!-- <button
    style="transform: translateY(300%) translateX(100%)"
    class="abort-btn"
  >
    Abort Controller
  </button> -->
  <div class="scene-task task-wrap">
    <div class="droppable-area"></div>
    <div
      :class="`character-wrap ${tasks[this.currentScene]['rabbit']['class']}`"
      :style="`width:${tasks[this.currentScene]['rabbit']['width']};
    left:${tasks[this.currentScene]['rabbit']['left']};
    top:${tasks[this.currentScene]['rabbit']['top']};`"
    >
      <lottie-animation
        ref="anime"
        class="character-anim"
        :path="tasks[this.currentScene]['rabbit']['json']"
        segment="59"
        :autoPlay="true"
        @AnimControl="setRabbitAnimController"
      />
    </div>
    <!-- task start -->
    <div
      v-for="(task, key) in tasks[this.currentScene]['task']"
      :key="key"
      @mouseup="TaskMouseup"
    >
      <div
        class="anchor"
        :task-id="`${key}`"
        :style="`top:${task['props']['top']}; 
        left:${task['props']['left']}; `"
      ></div>
      <div :class="`task-anim ${task['anim']['class']}`" :task-id="`${key}`">
        <lottie-animation
          ref="anime"
          :path="task['anim']['json']"
          :task-id="`${key}`"
          :segment="task['anim']['segment']"
          :successSegment="task['anim']['success-segment']"
          :autoPlay="true"
          @AnimControl="setAnimController"
        />
      </div>
      <img
        alt="props"
        class="props"
        :task-id="`${key}`"
        :src="task['props']['img']"
        :style="`width:${task['props']['width']}; 
        height:${task['props']['height']}; `"
        v-if="task['props']['img']"
      />
      <div
        :class="`props ${task['props']['class']}`"
        :style="`width:${task['props']['width']}; 
        height:${task['props']['height']}; `"
        v-if="task['props']['json']"
        :task-id="`${key}`"
      >
        <div class="">
          <lottie-animation
            :path="task['props']['json']"
            :autoPlay="true"
            :loop="true"
          />
        </div>
      </div>
      <div
        class="droppable"
        :task-id="`${key}`"
        :style="`top:${task['droppable']['top']}; 
        left:${task['droppable']['left']};
         width:${task['droppable']['width']}; 
        height:${task['droppable']['height']};`"
      >
        <h1>{{ key }}</h1>
      </div>
    </div>
    <!-- task end -->

    <!-- - start -->

    <lottie-animation
      ref="anime"
      :class="`character-anim  ${tasks[this.currentScene]['human']['class']}`"
      :path="tasks[this.currentScene]['human']['json']"
      :segment="tasks[this.currentScene]['human']['segment']"
      :walkSpeed="tasks[this.currentScene]['human']['walk-speed']"
      :successSegment="tasks[this.currentScene]['human']['success-segment']"
      :autoPlay="true"
      :data-scene="this.currentScene"
      @AnimControl="setHumanAnimController"
    />

    <!-- character end -->

    <!-- <lottie-animation
      ref="anime"
      :class="`character-anim  ${tasks[this.currentScene]['human']['class']}`"
      path="images/scene3b/t1-werewolf.json"
      :autoPlay="true"
      :data-scene="this.currentScene"
    /> -->
  </div>
</template>

<script>
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.min.css";
import "jquery-ui-touch-punch/jquery.ui.touch-punch.min.js";
import anime from "animejs";

import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
// import gameController from "../gameController";
import gameController from "./../gameController";
// import * as gameVariable from "../gameController";
import taskData from "./../assets/data/task.json";

export default {
  name: "Task",
  components: {
    LottieAnimation,
  },
  props: ["currentScene"],
  data() {
    return {
      taskAnim: [""],
      tasks: taskData,
      finishedTask: 0,
      segments: [""],
      endFrames: [""],
      humanAnim: "",
    };
  },
  created() {
    // console.log($("lottie-animation"));
    // $("lottie-animation").stop();
  },
  mounted() {
    this.ResetProps();
    this.DraggableProps();

    // scene 2 custom task
    if (this.currentScene == 2) {
      $(".s2-p3-card").mousedown(function () {
        $(".s2-light").addClass("hide");
        $(".s2-card-cover").addClass("picked");
      });
    }
  },
  methods: {
    setHumanAnimController: function (anim, id, e) {
      this.humanAnim = anim;
      var segment = $(e).attr("segment");
      var totalFrames = anim.totalFrames;
      var successFrame = $(e).attr("successSegment");
      var walkSpeed = $(e).attr("walkSpeed");
      var segmentLength = successFrame - segment;

      anim.playSegments([0, segment], true);

      this.emitter.on("human-leave", () => {
        var walkSegment;
        if (successFrame) {
          walkSegment = [parseInt(segment), parseInt(successFrame)];
        } else {
          // console.log("hooman no sucess segment");
          walkSegment = [parseInt(segment), parseInt(totalFrames)];
        }

        anim.setSpeed(walkSpeed);
        anim.playSegments(walkSegment, true);
        // console.log(walkSegment);
      });

      // console.log($(e).attr("data-scene"));
      // console.log("homan segment length: " + segmentLength);
      //loop success segment
      // console.log("hooman scene: " + $(e).attr("data-scene"));
      // console.log("current scene: " + this.currentScene);
      var lastFrameReached = false;

      anim.addEventListener(
        "enterFrame",
        function EnterFrame() {
          // console.log("enter frame: "+ $(e).attr("data-scene"));
          if (this.currentScene == $(e).attr("data-scene"))
            if (anim.currentFrame > segmentLength - 2 && !lastFrameReached) {
              // console.log("listening")
              //anim complete
              lastFrameReached = true;
              console.log("last frame reached");
              // console.log("hooman scene: " + $(e).attr("data-scene"));
              // console.log("current scene: " + this.currentScene);
              // console.log("segment length: " + segmentLength);
              // console.log("homan current frame: " + anim.currentFrame);
              // anim.setSpeed(1);

              //play success segement
              var successSegment = [
                parseInt(successFrame),
                parseInt(totalFrames),
              ];
              if (successFrame != null) {
                console.log(successSegment);
                anim.playSegments(successSegment, true);
              } else {
                anim.pause();
              }
              this.emitter.emit("show-exit", this.currentScene);
              console.log("[task] show exit]");

              //delay then to ending
              if (this.currentScene > 2) {
                // console.log("Add class");
                // $(".human-wrap").addClass("hide");
                //hide at this moment
                setTimeout(() => {
                  this.emitter.emit("show-ending");
                }, 1500);
              }

              anim.removeEventListener("enterFrame");
            }
          //remove
        }.bind(this)
      );
    },
    setRabbitAnimController: function (anim, id, e) {
      this.humanAnim = anim;
      var segment = $(e).attr("segment");
      var totalFrames = anim.totalFrames;
      var successFrame = $(e).attr("successSegment");
      var segmentLength = totalFrames - segment;

      anim.playSegments([0, segment], true);

      this.emitter.on("rabbit-leave", (scene) => {
        if (scene == this.currentScene) {
          var walkSegment = [parseInt(segment), parseInt(totalFrames)];
          anim.playSegments(walkSegment, true);
        }
      });
      console.log("task segment length: " + segmentLength);
      //loop success segment
      if (this.currentScene < 3) {
        anim.addEventListener(
          "enterFrame",
          function () {
            if (
              anim.currentFrame > segmentLength - 2 &&
              this.finishedTask == 3
            ) {
              //anim complete
              console.log("rabbit - last frame reached");
              //play success segement
              var successSegment = [
                parseInt(successFrame),
                parseInt(totalFrames),
              ];
              if (successFrame) {
                anim.playSegments(successSegment, true);
              } else {
                anim.pause();
              }
              $(".character-wrap").addClass("hide");
              // console.log("[rabbit]human leave");
              this.emitter.emit("human-leave");
              if (this.currentScene == 2) {
                $(".s2-lift").hide();
                console.log("hide lift");
              }
              anim.removeEventListener("enterFrame");
            }
          }.bind(this)
        );
      }
    },
    setAnimController: function (anim, id, e) {
      // console.log("setAnimController: task");
      // console.log("Anim id=" + id);
      // console.log(anim);
      // console.log("total frame: " + anim.totalFrames);
      this.taskAnim[id] = anim;
      var segment = $(e).attr("segment");
      var totalFrames = anim.totalFrames;
      this.segments[id] = segment;
      this.endFrames[id] = totalFrames;
      // console.log("total frames: "+totalFrames);
      if (segment && segment > 0) {
        // console.log("play segment");
        anim.playSegments([0, segment], true);
      } else {
        anim.pause();
      }

      var segmentLength = totalFrames - segment;
      // console.log(id + " | segment: " + segment);
      // console.log(id + " | segmentlength: " + segmentLength);
      // console.log(id + " | total frame: " + totalFrames);

      anim.addEventListener(
        "enterFrame",
        function () {
          // console.log(id+" - current:" + anim.currentFrame );
          // if (id == 2) console.log("[id]enterFrame", anim.currentFrame);
          if (anim.currentFrame > segmentLength - 2) {
            //anim complete
            // console.log("last frame reached");
            // console.log("current:" + anim.currentFrame + "last:" + totalFrames);
            //play success segement
            var successFrame = $(e).attr("successSegment");
            if (successFrame) {
              // console.log(
              //   "success segment: " + successSegment + ", " + totalFrames
              // );
              var successSegment = [
                parseInt(successFrame),
                parseInt(totalFrames),
              ];
              anim.playSegments(successSegment, true);
            } else {
              anim.pause();
            }
            this.finishedTask++;

            // console.log("anim complete:" + this.finishedTask);
            // console.log(this);
            if (this.finishedTask == 3) {
              anim.removeEventListener("enterFrame");
              if (this.currentScene < 3) {
                // this.emitter.emit("rabbit-leave", this.currentScene);
                this.emitter.emit("human-leave", this.currentScene);
              // } else if (this.currentScene < 3) {
              //   this.emitter.emit("rabbit-leave", this.currentScene);
              } else {
                // console.log("[task success]human leave");
                this.emitter.emit("human-leave", this.currentScene);
              }
            }
          }
        }.bind(this)
      );
    },
    ResetProps: function () {
      // console.log("reset props");

      $(".props:not(.success)").each(function () {
        var id = $(this).attr("task-id");
        var anchor = $(".anchor[task-id='" + id + "']");

        // var top = $(anchor).css("top");
        // var left = $(anchor).css("left");
        var pos = gameController.GetAnchorPosition(anchor);
        var top = pos[0];
        var left = pos[1];
        $(this).css("top", top);
        $(this).css("left", left);
        // console.log(gameController.GetAnchorPosition(anchor));
        // console.log("anchor id: " + id);
        // console.log($(anchor));
        // console.log("top: " + top);
        // console.log("left: " + left);
      });
    },
    DraggableProps() {
      // var props = $(".props");
      $(".props").each(function () {
        $(this).draggable({
          cursorAt: { left: 0, top: 0 },
          containment: ".droppable-area",
          start: function (event, ui) {
            //center pointer
            $(this).draggable("instance").offset.click = {
              left: Math.floor(ui.helper.width() / 2),
              top: Math.floor(ui.helper.height() / 2),
            };
          },
        });
      });
      $(".droppable").droppable({
        tolerance: "intersect",
        drop: function (e, ui) {
          var draggable_id = ui.draggable.attr("task-id");
          var droppable_id = $(e.target).attr("task-id");
          if (draggable_id == droppable_id) {
            // console.log("[Task] drop success");
            //task success
            //hide props
            $(ui.draggable).addClass("success");
            //show anim
            //1. pause
            this.taskAnim[draggable_id].pause();
            // successtimeline
            var animDiv = $(".task-anim[task-id=" + draggable_id + "]");
            var success_tl = anime.timeline({
              autoplay: false,
            });
            var anim_time = 1000;
            anim_time = 0;
            if ($(animDiv).hasClass("always-show")) {
              anim_time = 0;
            }

            //2. fade out
            success_tl.add({
              duration: anim_time,
              begin: function () {
                // $(animDiv).addClass("hide");
                // console.log("[Task] timeline 2");
              }.bind(this),
              complete: function () {
                // console.log("[Task] timeline 3");
                // console.log("--segment:" + this.segments[draggable_id]);
                // console.log("--end frame: " + this.endFrames[draggable_id]);
                var start = parseInt(this.segments[draggable_id]) + 1;
                var end = parseInt(this.endFrames[draggable_id]);
                var segment = [start, end];
                // console.log(segment);
                this.taskAnim[draggable_id].playSegments(segment, true);
                // $(animDiv).removeClass("hide");
              }.bind(this),
            });
            success_tl.restart();

            // scene 2 custom
            if (this.currentScene == 2) {
              if (droppable_id == 0) {
                //task: card
                $(".s2-light").addClass("finish");
              }
            }
          }
        }.bind(this),
      });
    },
    TaskMouseup() {
      setTimeout(
        function () {
          this.ResetProps();
        }.bind(this),
        100
      );
      // scene 2 custom task
      if (this.currentScene == 2) {
        // $(".s2-light").addClass("hide");
        $(".s2-light").removeClass("hide");
        $(".s2-card-cover").removeClass("picked");
      }
    },
  },
};
</script>


